export default function nFormatter(num, digits) {

  const lookup = [
    { value: -1, symbol: "" },
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "Bn" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

  let absoluteNumber = Math.abs(num);

  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      console.log(item);
      return absoluteNumber >= item.value;
    });
  if (num < 0) 
  {
    if (item.value === -1) {
      return Math.abs(
        item
          ? (absoluteNumber / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
          : "0"
      );
    }
    return item
      ? (absoluteNumber / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
      : "0";
  }
  else
  {
    if (item.value === -1) {
      return Math.abs(
        item
          ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
          : "0"
      );
    }
    return item
      ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
      : "0";
  }  
}
